<div class="c-fitBlock">
  <div class="c-fitBlock__item c-fitBlock__item--center">
    <div class="c-loginForms">
      <div class="d-flex justify-content-center brand-logo">
        <img src="assets/images/brand-lg.png" alt="Storeverse" />
      </div>

      <div class="c-formSection">
        <form (keyup.enter)="handleLogin()">
          <div class="form-block">
            <label
              for="username"
              class="form-label"
              i18n="@@244aae9346da82b0922506c2d2581373a15641cc"
              >User Name</label
            >
            <input
              type="text"
              class="form-control form-control--default"
              id="username"
              name="username"
              [(ngModel)]="credentials.username"
            />
          </div>
          <div class="form-block">
            <label
              for="password"
              class="form-label"
              i18n="@@c32ef07f8803a223a83ed17024b38e8d82292407"
              >Password</label
            >
            <input
              type="password"
              class="form-control form-control--default"
              id="password"
              name="password"
              [(ngModel)]="credentials.password"
            />
          </div>
          <div class="text-center">
            <button 
              class="btn btn-primary"
              (click)="handleLogin()"
              *ngIf="!isLoading"
              i18n="@@729411b7f2d3f8d9112be6db06e97d485d6efdae"
            >
              <span class="c-btn__title">Log in</span>
            </button>
            <button
              disabled
              type="button"
              class="btn btn-primary"
              *ngIf="isLoading"
            >
              <span
                role="status"
                aria-hidden="true"
                class="spinner-border spinner-border-sm"
              ></span>
              Loading...
            </button>
          </div>
        </form>
      </div>

      <div
        class="copy-text text-center mt-3"
        i18n="@@da4a5c66abf24158891d54cecd08d0dd9c660313"
      >
        <strong>Store</strong>verse Backoffice
      </div>
    </div>
  </div>
  <div
    class="c-fitBlock__item c-fitBlock__item--image"
    style="
      background-image: url(&quot;assets/images/background/auth_splash.jpg&quot;);
    "
  ></div>
</div>
